import palette from 'theme/palette';

export default {
  paper: {
    borderRadius: 16,
    boxShadow: '0px 7px 24px rgba(26, 38, 38, 0.1)',
    border: `1px solid ${palette.grey[300]}`,
  },
};
